export enum SnackbarTestIds {
  TITLE = 'snackbar-title',
  MESSAGE = 'snackbar-message',
}
